import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const pastDate = createSlice({
    name: "pastDate",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setpastDateReducer: (state, action) => {
            state.value = action.payload;
        },
        clearpastDateReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setpastDateReducer, clearpastDateReducer } = pastDate.actions;
export default pastDate.reducer;
